import { Title, Flex, Button } from '@mantine/core';
import { modals } from '@mantine/modals';

import {
  useGetShopCommissions,
  ShopCommissionsTable,
  CreateShopCommissionForm,
} from '@/modules/shop-commissions';

export const ShopCommissions = () => {
  const {
    params,
    items,
    itemsCount,
    isLoading,
    handlePaginationChange,
  } = useGetShopCommissions({});

  const openCreateModal = () => modals.open({
    title: 'Создание комиссии магазина',
    centered: true,
    children: (
      <CreateShopCommissionForm
        onClose={modals.closeAll}
      />
    ),
  });

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Комиссии магазинов</Title>

        <Button
          variant="filled"
          onClick={openCreateModal}
        >
          Создать
        </Button>
      </Flex>

      <ShopCommissionsTable
        items={items}
        isLoading={isLoading}
        itemsCount={itemsCount}
        pageSize={params.pageSize}
        currentPage={params.page}
        onPageChange={handlePaginationChange}
      />
    </>
  );
};
